export function charValue(char) {
  return char.toUpperCase().charCodeAt(0) - 48;
}

export function expectedCheckDigit(sum) {
  const rest = sum % 11;
  return rest < 2 ? 0 : 11 - rest;
}

export function dotProduct(values, weights) {
  return values.reduce((acc, value, index) => acc + value * weights[index], 0);
}

export function calculateDigit(values, weights) {
  return expectedCheckDigit(dotProduct(values, weights));
}

export function isRepeatedSequence(value) {
  return /^(.)\1+$/.test(value);
}
